import { StringFormat } from "./string-format";

// cspell:disable-next-line
const CROCKFORD32_ALPHABET = "0123456789ABCDEFGHJKMNPQRSTVWXYZ";

function encodeBigInt(input: bigint): string {
  if (input === 0n) {
    return "0";
  }

  let buffer = input;
  let result = "";

  while (buffer > 0n) {
    result = CROCKFORD32_ALPHABET.charAt(Number(buffer % 32n)) + result;
    buffer = buffer / 32n;
  }

  return result;
}

function decodeToBigInt(input: string): bigint {
  const normalized = input
    .toUpperCase()
    .replace(/O/g, "0")
    .replace(/[IL]/g, "1")
    .replace(/-+/g, "");

  let result = 0n;
  for (const char of normalized) {
    const value = CROCKFORD32_ALPHABET.indexOf(char);
    if (value === -1) {
      throw new Error(`Invalid character: ${char}`);
    }
    result = result * 32n + BigInt(value);
  }

  return result;
}

export interface Crockford32Options {
  prefix?: string;
}

export function crockford32StringFormat({
  prefix = "",
}: Crockford32Options = {}): StringFormat<bigint> {
  return {
    read(string: string): bigint {
      if (prefix && !string.startsWith(prefix)) {
        throw new Error(`String must start with prefix "${prefix}"`);
      }
      const encodedPart = prefix ? string.slice(prefix.length) : string;
      return decodeToBigInt(encodedPart);
    },
    write(value: bigint): string {
      return prefix + encodeBigInt(value);
    },
  };
}
